import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { KeyValue } from '@angular/common';
import { cloneDeep } from 'lodash';

import { ToolAdapterService } from './tools/tool-adapter.service';
import { LayoutDesignerComponent } from './components/layout-designer/layout-designer.component';
import { ToolBoxComponent } from './components/tool-box/tool-box.component';
import { FormEventGroupComponent } from './components/form-event-group/form-event-group.component';
import { ControlDesignArgs } from './types/designer.types';
import { ControlEvent, ControlDataModel, ControlViewModel } from './types/control.types';
import { toDynamicFormModel, DynamicFormEvent, DynamicFormModel } from './utils/dynamic-form-model';
import { ControlSpecification } from './types/specification.types';
import {
  SelectCondition,
  ShowCondition,
  ControlModelPropertyEnum,
  FormPublishDataModelDataEntityProperty
} from './types';
import { ControlSharedService } from './services/control-shared.service';
import { ShowHiddenRuleModel } from './types/control-show-hidden.types';
import { ShowHiddenEntryComponent } from './components/show-hidden/show-hidden-entry/show-hidden-entry.component';
import { SpecificationHelperService } from './services/specification-helper.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dynamic-form-designer',
  templateUrl: './dynamic-form-designer.component.html',
  styleUrls: ['./dynamic-form-designer.component.css'],
  providers: [ControlSharedService]
})
export class DynamicFormDesignerComponent implements OnInit {
  @Input() set model(val: any) {
    const formModel = toDynamicFormModel(val);
    formModel.controls.forEach((s) =>
      this.filterDataModel(s, (dataModel) => {
        this.filterAssociatedEntityAttributes(dataModel.model);
      })
    );
    this.controlDataModels = formModel.controls;
    this.formEventModels = formModel.form.events;
    this.showHiddenRuleModels = formModel.form.showHiddenRules;
  }

  @Input() formCode: string;

  @Input() globalData: any;

  /**
   * ç¦ç¨æ§ä»¶çæä½
   *
   */
  @Input() disableOperateControl: boolean;

  /**
   * ç¦ç¨æ°æ®å®ä½éæ©
   *
   */
  @Input() disableEditEntityProperty: boolean;

  /**
   *  @description éè
   *
   * @memberof DynamicFormDesignerComponent
   */
  isHidden: boolean = true;
  /**
   * @description é¢è§DataModel
   *
   * @memberof DynamicFormDesignerComponent
   */
  previewFormModel: any;

  /**
   * @description æ¯å¦æ¾ç¤ºè¡¨åå±æ§
   *
   * @memberof DynamicFormDesignerComponent
   */
  isShowFormProperty: boolean = false;
  /**
   * @description ææ½æ·»å çæ§ä»¶è§æ ¼
   *
   * @memberof DynamicFormDesignerComponent
   */
  dragSpecification: ControlSpecification;

  /**
   * @description æ¥è¯¢æ¡ä»¶
   * @memberof DynamicFormDesignerComponent
   */
  selectConditions: Array<SelectCondition> = [];
  /**
   * @description å±ç¤ºåæ¡ä»¶
   * @memberof DynamicFormDesignerComponent
   */
  showConditions: Array<ShowCondition> = [];

  controlDataModels: Array<ControlDataModel>;
  formEventModels: Array<ControlEvent>;
  showHiddenRuleModels: Array<ShowHiddenRuleModel>;

  @ViewChild(LayoutDesignerComponent) layoutDesigner: LayoutDesignerComponent;
  @ViewChild(ToolBoxComponent) toolBox: ToolBoxComponent;
  @ViewChild(FormEventGroupComponent) formEventGroupComponent: FormEventGroupComponent;
  @ViewChild(ShowHiddenEntryComponent) showHiddenComponent: ShowHiddenEntryComponent;

  get selected(): ControlDesignArgs {
    return this._selected;
  }
  set selected(value: ControlDesignArgs) {
    this._selected = value;
  }

  associatedEntitiesName: string;
  entityAttributeName: string;

  private _selected: ControlDesignArgs = {};

  constructor(
    private toolAdapter: ToolAdapterService,
    public controlShared: ControlSharedService,
    private specificationHelperService: SpecificationHelperService
  ) {
    this.associatedEntitiesName = ControlModelPropertyEnum.AssociatedEntities;
    this.entityAttributeName = ControlModelPropertyEnum.EntityAttribute;
    controlShared.isDesign = true;
  }

  ngOnInit() {
    this.toolAdapter.designer = this;
  }

  /**
   * @description è·åè¡¨åmodel
   *
   * @memberof DynamicFormDesignerComponent
   */
  getFormModel(): DynamicFormModel {
    const dataModel = this.layoutDesigner.getDataModels();
    // åå°contentå¤§å°
    dataModel.forEach((s) => this.filterDataModel(s));
    const formEventModel = this.getFormEventModels();
    const showHiddenRuleModels = this.getFormShowHiddenModels();
    return {
      form: { events: formEventModel, showHiddenRules: showHiddenRuleModels },
      controls: dataModel
    };
  }

  /**
   * @description è·åè¡¨åäºä»¶
   *
   * @memberof DynamicFormDesignerComponent
   */
  getFormEventModels(): Array<DynamicFormEvent> {
    return this.formEventGroupComponent.getModels();
  }

  /**
   * @description è·åè¡¨åäºä»¶
   *
   * @memberof DynamicFormDesignerComponent
   */
  getFormShowHiddenModels(): Array<ShowHiddenRuleModel> {
    return this.showHiddenComponent.getModels();
  }

  /**
   * @description æ¾ç¤ºé¢è§
   *
   * @memberof DynamicFormDesignerComponent
   */
  preview() {
    this.previewFormModel = cloneDeep(this.getFormModel());
    this.isHidden = false;
  }

  /**
   * @description æ¾ç¤ºè®¾è®¡
   *
   * @memberof DynamicFormDesignerComponent
   */
  design() {
    this.isHidden = true;
  }

  // è·ååå¸æ¶çæ°æ®ç»æ
  /**
   * @description è·ååå¸æ§ä»¶DataModel
   *
   * @memberof DynamicFormDesignerComponent
   */
  getPublishDataModels(): {
    success: boolean;
    groups: KeyValue<string, FormPublishDataModelDataEntityProperty[]>[];
  } {
    const modelGroups: KeyValue<string, FormPublishDataModelDataEntityProperty[]>[] = [];
    const controlDataModels = this.getFormModel().controls;

    this.selectConditions = [];
    this.showConditions = [];
    this.getQueryConditions(controlDataModels);
    const publishModels = this.getPublishDataModelsBy(controlDataModels);

    for (const s of publishModels) {
      let items: FormPublishDataModelDataEntityProperty[];
      if (s.associatedEntities === undefined) {
        continue;
      }
      const groupName = s.associatedEntities;

      const filteredGroups = modelGroups.filter((x) => x.key === groupName);

      if (filteredGroups.length === 0) {
        const groupItem = {
          key: groupName,
          value: new Array<FormPublishDataModelDataEntityProperty>()
        };
        modelGroups.push(groupItem);
        items = groupItem.value;
      } else {
        items = filteredGroups[0].value;
      }
      const success = this.fillModelDataItem(s, items, groupName);
      if (!success) {
        return { success: false, groups: undefined };
      }
    }

    return { groups: modelGroups, success: true };
  }

  /**
   * å¡«åæ°æ®item
   *
   */
  private fillModelDataItem(
    controlViewModel: ControlViewModel,
    items: FormPublishDataModelDataEntityProperty[],
    groupName: string
  ): boolean {
    // TODO æªæ¥çæ¬è¦ç§»é¤æ­¤å¼å®¹æ§
    for (const key in controlViewModel) {
      if (controlViewModel.hasOwnProperty(key)) {
        if (key.startsWith(ControlModelPropertyEnum.EntityAttribute)) {
          const existItem = items.find((x) => x.target === key);
          if (!existItem) {
            items.push({ target: controlViewModel[key], controlViewModel });
          } else {
            // æç¤ºæéå¤ï¼ä¸è®©ä¿å­ï¼ï¼
            const errorMsg = this.getEntityNotRepeatMsg(
              existItem.controlViewModel.name,
              controlViewModel.name,
              groupName,
              controlViewModel[key]
            );
            this.controlShared.commonConfig.log.error(errorMsg);
            return false;
          }
        }
      }
    }
    // æ°æ ¼å¼æ¥æ´æ°é»è®¤æ¨¡å¼
    if (controlViewModel.associatedEntityAttributes) {
      for (const e of controlViewModel.associatedEntityAttributes) {
        if (e.target) {
          if (e.jsonKey) {
            // jsonKeyéå¤
            const existItem = items.find((x) => x.target === e.target && x.jsonKey === e.jsonKey);
            if (existItem) {
              const errorMsg = `${this.getEntityNotRepeatMsg(
                existItem.controlViewModel.name,
                controlViewModel.name,
                groupName,
                e.target
              )}jsonKeyã${e.jsonKey}ã`;
              this.controlShared.commonConfig.log.error(errorMsg);
              return false;
            }
          } else {
            // targetéå¤
            const existItem = items.find((x) => x.target === e.target);
            if (existItem) {
              const errorMsg = this.getEntityNotRepeatMsg(
                existItem.controlViewModel.name,
                controlViewModel.name,
                groupName,
                e.target
              );
              this.controlShared.commonConfig.log.error(errorMsg);
              return false;
            }
          }
          items.push({ target: e.target, jsonKey: e.jsonKey, controlViewModel });
        }
      }
    }
    return true;
  }

  // è·åæ¥è¯¢åå±ç¤ºæ¡ä»¶
  getQueryConditions(controlDataModels: ControlDataModel[]) {
    controlDataModels.forEach((s) => {
      const selectCondition = this.getSelectCondition(s);
      if (selectCondition && selectCondition.dataAttrCode) {
        this.selectConditions.push(selectCondition);
      }

      const showCondition = this.getShowCondition(s);
      if (showCondition && (showCondition.dataAttrCode || showCondition.multiDataAttrCode.length > 0)) {
        this.showConditions.push(showCondition);
      }
      if (s.children) {
        this.getQueryConditions(s.children);
      }
    });
  }

  /**
   * è·åæ¥è¯¢æ¡ä»¶
   *
   * @memberof DynamicFormDesignerComponent
   */
  getSelectCondition(controlDataModel: ControlDataModel): SelectCondition {
    const model = controlDataModel.model;
    const condition = model.selectCondition;

    if (!condition || !condition.checked) {
      return null;
    }

    const res: SelectCondition = {
      type: condition.templateType || controlDataModel.type,
      dataEntityCode: model[this.associatedEntitiesName],
      dataAttrCode: condition.entityAttribute,
      // dataAttrOrigin:  model[getOriginPropertyName(this.entityAttributeName)],
      serialNo: condition.serialNo,
      rule: condition.rule,
      caption: model.caption,
      model: {}
    };

    const associatedEntity = this.specificationHelperService.dataEntities.find((s) => s.name === res.dataEntityCode);
    if (associatedEntity) {
      res.dataAttrOrigin = associatedEntity.properties.find((s) => s.name === res.dataAttrCode);
    }
    const optionName = ControlModelPropertyEnum.Option;
    if (model[optionName]) {
      res.model[optionName] = model[optionName];
    }
    return res;
  }

  /**
   * è·åå±ç¤ºåæ¡ä»¶
   *
   * @memberof DynamicFormDesignerComponent
   */
  getShowCondition(controlDataModel: ControlDataModel): ShowCondition {
    const model = controlDataModel.model;
    const condition = model.showCondition;

    if (!condition || !condition['checked']) {
      return null;
    }

    const res: ShowCondition = {
      type: controlDataModel.type,
      dataEntityCode: model.associatedEntities,
      dataAttrCode: model.entityAttribute,
      multiDataAttrCode: this.getShowConditionMultiAttrCode(condition),
      serialNo: condition['serialNo'],
      caption: model.caption,
      model: {}
    };
    const optionName = ControlModelPropertyEnum.Option;
    if (model[optionName]) {
      res.model[optionName] = model[optionName];
    }
    return res;
  }

  /**
   * è·åShowConditionEditorä¸­å¤å±æ§çå±ç¤ºå
   *
   *
   * @memberOf DynamicFormDesignerComponent
   */
  getShowConditionMultiAttrCode(condition: any): any[] {
    const checkedEntityAttributes: any[] = condition['checkedEntityAttributes'];
    if (!checkedEntityAttributes) {
      return [];
    }
    return checkedEntityAttributes;
  }

  /**
   * @description è®¾ç½®æ¯å¦æ¾ç¤ºè¡¨åäºä»¶
   *
   * @param  isShow æ¯å¦æ¾ç¤º
   * @memberof DynamicFormDesignerComponent
   */
  showFormProperty(isShow: boolean) {
    this.isShowFormProperty = isShow;
  }

  /**
   * @description toolåæéæ©å·¥å·
   *
   * @param event å³é®äºä»¶event
   * @memberof DynamicFormDesignerComponent
   */
  nomenu(event: any) {
    // ä¸»è¦æ¯è¿ä¸ªäºä»¶äºï¼é»æ­¢é»è®¤å³é®èåçå¼¹åº
    event.preventDefault();
    // åæ¢å·¥å·ä¸ºéæ©
    this.toolAdapter.startSelect();
  }

  /**
   *  è¿æ»¤dataModel
   *
   * @memberof DynamicFormDesignerComponent
   */
  private filterDataModel(
    controlDataModel: ControlDataModel,
    ...callBack: ((controlDataModel: ControlDataModel) => void)[]
  ) {
    if (!controlDataModel.model) {
      return;
    }

    if (callBack) {
      callBack.forEach((s) => {
        s(controlDataModel);
      });
    }

    if (controlDataModel.children && controlDataModel.children.length) {
      controlDataModel.children.forEach((s) => {
        this.filterDataModel(s, ...callBack);
      });
    }
  }

  /**
   * å¤çå®ä½å±æ§ï¼èªå¨åæ´ä¸ºæ°çç»æ
   */
  private filterAssociatedEntityAttributes(model: ControlViewModel) {
    const entityAttributes = Object.keys(model).filter((s) => {
      return s.startsWith(this.entityAttributeName);
    });
    entityAttributes.forEach((s) => {
      if (typeof s !== 'string') {
        return;
      }

      const propertyCode = s.substring(this.entityAttributeName.length);
      if (!model.associatedEntityAttributes) {
        model.associatedEntityAttributes = [];
      }

      if (!model.associatedEntityAttributes.find((attribute) => attribute.source === propertyCode)) {
        model.associatedEntityAttributes.push({
          source: propertyCode,
          target: model[s]
        });
      }

      model[s] = undefined;
    });
  }

  // è·åæ§ä»¶ç»å®çæ°æ®ç¼ç 
  private getPublishDataModelsBy(dataModels: Array<ControlDataModel>): Array<ControlViewModel> {
    const publishModels: Array<ControlViewModel> = [];
    dataModels.forEach((s) => {
      const data = s.model as ControlViewModel;
      if (data != null) {
        publishModels.push(data);
      }
      if (s.children != null) {
        const models = this.getPublishDataModelsBy(s.children);
        publishModels.push(...models);
      }
    });

    return publishModels;
  }

  private getEntityNotRepeatMsg(oldControlName: string, controlName: string, entityName: string, propertyName: string) {
    return `æ§ä»¶ã${oldControlName}ãä¸æ§ä»¶ã${controlName}ãå­å¨ç¸åå®ä½ã${this.getEntityCaption(
      entityName
    )}ãå±æ§ã${this.getEntityPropertyCaption(entityName, propertyName)}ã`;
  }

  private getEntityCaption(entityCode: string) {
    const entity = this.specificationHelperService.dataEntities.find((s) => s.name === entityCode);
    if (entity) {
      return entity.caption;
    }
    return '';
  }

  private getEntityPropertyCaption(entityCode: string, propertyName: string) {
    const entity = this.specificationHelperService.dataEntities.find((s) => s.name === entityCode);
    if (entity) {
      const property = entity.properties.find((s) => s.name === propertyName);
      if (property) {
        return property.caption;
      }
    }
    return '';
  }
}
